<template>
  <aside class="summary">
    
    <div class="row">
      <div class="title">
        <h5>Subtotal</h5>
      </div>
      <div class="price">
        <h5><span>$</span>{{ modFormatAmount(cart.summary.sub_total) }}</h5>
      </div>
    </div>
    
    <div
      v-if="!showProceed"
      class="shipping-info"
    >
      <div class="row">
        <div class="title">
          <h5>Shipping</h5>
          <p>{{ cart.shipping_info.region_name }}</p>
        </div>
        <div class="price">
          <h5><span>$</span>{{ modFormatAmount(cart.summary.shipping) }}</h5>
        </div>
      </div>
    
      <div class="row">
        <div class="title">
          <h5>GST</h5>        
        </div>
        <div class="price">
          <h5><span>$</span>{{ modFormatAmount(cart.summary.tax_total) }}</h5>
        </div>
      </div>
      
      <div class="row total">
        <div class="title">
          <h5>Total Cost</h5>
        </div>
        <div class="price">
          <h5><span>$</span>{{ modFormatAmount(cart.summary.total) }}</h5>
        </div>
      </div>
    </div>
    
    <div class="buttons">
      <button
        class="button large orange"
        v-if="showProceed"
        @click="goToCheckout"
        :disabled="disableButton"
      >
        CHECKOUT
      </button>
    </div>

    <p
      class="note"
      v-if="showProceed"
    >
      Shipping is added at checkout.
    </p>
    
  </aside>  
</template>

<script>
  export default {
    props: {
      showProceed: Boolean
    },

    data () {
      return {
        disableButton: false,
      }
    },

    computed: {
      cart () {
        return this.$store.state.cart
      }
    },

    methods: {
      goToCheckout () {
        this.disableButton = true
        window.location.href = '/checkout'
      }
    }

  }
</script>

<style lang="scss">
.summary {
  width: 100%;

  .row {
    display: flex;
    width: 100%;
    padding: 20px 0;

    .title,
    .price {
      width: 50%;

      h5 {
        margin: 0;

        font-size: 18px;
        line-height: 28px;
      }
    }

    .price {
      text-align: right;
    }
  }

  .buttons {
    .button {
      width: 100%;
    }
  }

  p.note {
    margin: 10px 0 20px;

    font-size: 12.5px;
    line-height: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/Summary.vue